var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feedback-step question--yes-no"},[_c('div',{staticClass:"heading-third--grey "},[_vm._v(_vm._s(_vm.feedbackData.text))]),_c('QuestionError',{attrs:{"showEmptyError":_vm.showEmptyError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }